import { COLORS } from '../lib/theme'

/**
 * A quiet pulsing "live" dot marking a hunt that is happening right now.
 * Informational only. The pulse lives in `.wh-live-dot` (styles/components.css),
 * which also stops it under `prefers-reduced-motion: reduce`.
 */
export function LiveDot({ size = 7, color = COLORS.tertiary }: { size?: number; color?: string }) {
  return (
    <span style={{ position: 'relative', width: size, height: size, flex: 'none', display: 'inline-block' }}>
      <span
        className="wh-live-dot"
        style={{ position: 'absolute', inset: 0, borderRadius: 999, background: color }}
      />
    </span>
  )
}
